<template>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.6604 7.16239C16.9656 2.99986 11.4635 1.76235 7.19667 4.34987C3.04208 6.93739 1.69464 12.5624 4.38951 16.725L4.61408 17.0625L3.71579 20.4375L7.08438 19.5375L7.42124 19.7625C8.88096 20.55 10.453 21 12.025 21C13.7093 21 15.3936 20.55 16.8533 19.65C21.0079 16.95 22.243 11.4374 19.6604 7.16239ZM17.3024 15.825C16.8533 16.5 16.2919 16.95 15.5058 17.0625C15.0567 17.0625 14.4953 17.2875 12.2495 16.3875C10.3407 15.4875 8.76868 14.0249 7.64581 12.3374C6.9721 11.5499 6.63524 10.5374 6.52295 9.52491C6.52295 8.62491 6.85981 7.8374 7.42124 7.2749C7.64581 7.04989 7.87039 6.93739 8.09496 6.93739C8.31953 6.93739 8.43182 6.93739 8.65639 6.93739C8.88096 6.93739 9.10553 6.93739 9.21782 7.3874C9.44239 7.9499 10.0038 9.29991 10.0038 9.41241C10.1161 9.52491 10.1161 9.74991 10.0038 9.86241C10.1161 10.0874 10.0038 10.3124 9.89154 10.4249C9.77925 10.5374 9.66697 10.7624 9.55468 10.8749C9.33011 10.9874 9.21782 11.2124 9.33011 11.4374C9.77925 12.1124 10.3407 12.7874 10.9021 13.3499C11.5758 13.9124 12.2495 14.3624 13.0356 14.7C13.2601 14.8125 13.4847 14.8125 13.597 14.5875C13.7093 14.3624 14.2707 13.7999 14.4953 13.5749C14.7198 13.3499 14.8321 13.3499 15.0567 13.4624C15.2813 13.5749 16.6287 14.2499 16.8533 14.3624C17.0779 14.4749 17.3024 14.5875 17.4147 14.7C17.527 15.0375 17.527 15.4875 17.3024 15.825Z"
            :fill="color" 
        />
    </svg>
</template>
<script>
export default {
    name: "WhatsappIcon",
    props: {
        color: {
            type: String,
            default: '#3A3F48',
        },
    },
};
</script>
<style scoped>
</style>
